<script setup lang="ts">
import { iconsMapAtomsMessage } from '@design-system/components/Atoms/Message/AtomsMessageInfo.iconsMapping'

import type { UIFinalSalesProps } from './UIFinalSales.props'
const props = defineProps<UIFinalSalesProps>()

const { openDialog: openInfoReturnSidebar } = useDialog(props.sidebarId)
</script>
<template>
  <div
    class="flex w-full items-center"
    :class="`${
      !isPdpLabel ? 'bg-neutral-gray gap-[10px] px-4 py-[10px]' : 'gap-1'
    } ${customClass || ''} `"
  >
    <component
      :is="iconsMapAtomsMessage[icon]"
      v-if="icon"
      class="h-4 w-4"
      aria-hidden="true"
    />
    <p class="w-fit" :class="isPdpLabel ? 'text-book-8' : 'text-book-6'">
      {{ $ts('pdp.productDetails.finalSale') }}
    </p>
    <button
      :aria-label="$ts('accessibility.openReturnInfoSidebar')"
      @click="() => openInfoReturnSidebar()"
    >
      <DefaultIconsInfo class="h-4 w-4" aria-hidden="true" />
    </button>
  </div>
</template>
